import { createContext } from "react";

export const TumanContext = createContext();
